import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { FolderNavigationProvider } from './contexts/FolderNavigationContext';
import { Login } from './modules/auth';
import { Layout } from './layout';
import DocumentationMain from './modules/documentation/DocumentationMain';
import { UserManagement } from './modules/users';

const AppRoutes: React.FC = () => {
  const { state } = useAuth();

  if (state.loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg text-gray-600">Cargando...</div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Ruta de login */}
      <Route path="/login" element={<Login />} />
      
      {/* Rutas protegidas */}
      {state.isAuthenticated ? (
        <>
          <Route path="/documentation" element={
            <FolderNavigationProvider>
              <Layout>
                <DocumentationMain />
              </Layout>
            </FolderNavigationProvider>
          } />
          
          {/* Ruta de gestión de usuarios - solo para administradores */}
          {state.user?.role === 'admin' && (
            <Route path="/users" element={
              <FolderNavigationProvider>
                <Layout>
                  <UserManagement />
                </Layout>
              </FolderNavigationProvider>
            } />
          )}
          
          <Route path="/" element={<Navigate to="/documentation" replace />} />
        </>
      ) : (
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
      
      {/* Catch all */}
      <Route path="*" element={<Navigate to={state.isAuthenticated ? "/documentation" : "/login"} replace />} />
    </Routes>
  );
};

export default AppRoutes;